var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgImage(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.3028 0.75H5.65076C2.63876 0.75 0.749756 2.884 0.749756 5.904V14.05C0.749756 17.07 2.63076 19.204 5.65076 19.204H14.2978C17.3228 19.204 19.2028 17.07 19.2028 14.05V5.904C19.2068 2.884 17.3258 0.75 14.3028 0.75Z",
    stroke: "#4F4F4F",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.70311 6.78545C8.70311 7.80545 7.87711 8.63145 6.85711 8.63145C5.83811 8.63145 5.01111 7.80545 5.01111 6.78545C5.01111 5.76545 5.83811 4.93945 6.85711 4.93945C7.87611 4.94045 8.70211 5.76645 8.70311 6.78545Z",
    stroke: "#4F4F4F",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M19.207 12.951C18.284 12.001 16.509 10.082 14.579 10.082C12.648 10.082 11.535 14.315 9.678 14.315C7.821 14.315 6.134 12.401 4.646 13.628C3.158 14.854 1.75 17.361 1.75 17.361",
    stroke: "#4F4F4F",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgImage);
export default __webpack_public_path__ + "static/media/image.59cb986b5eab50a8ce7bab222edb73a0.svg";
export { ForwardRef as ReactComponent };